import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { usePreventRecordingInterruptions } from "@hooks";
import { useNavigate } from "react-router";

export default function TeamInvite({ invite }) {
  const { handleActionWithPrevention } =
    usePreventRecordingInterruptions();
  const navigate = useNavigate();
  function handleTeamInviteClick() {
    navigate(`/teams/accept/${invite.uuid}`);
  }
  return (
    <div className="w-full" data-testid="team-invite">
      <a
        href={`/teams/accept/${invite.uuid}`}
        rel="noopener noreferrer"
        onClick={(e) => e.preventDefault()}
        className="no-underline!"
      >
        <div
          className={`cursor-pointer hover:bg-brand-subtle
            p-3 bg-brand-subtle border border-brand
            rounded-lg
            self-center flex flex-col transition-all shadow-xs`}
          onClick={() =>
            handleActionWithPrevention(handleTeamInviteClick)
          }
        >
          <div className="flex flex-col items-start w-full">
            <div className="flex flex-row items-center w-full">
              <div className="flex-1 mr-2">
                <div className="text-xs text-primary">
                  <FontAwesomeIcon icon={faUsers} />
                  &nbsp;
                  {invite.sender.firstName} {invite.sender.lastName}
                  &nbsp;has invited you to join the team{" "}
                  {invite.team.name}. Click to view.
                </div>
              </div>
            </div>
            <div className="flex flex-row justify-between w-full flex-1 items-end"></div>
          </div>
        </div>
      </a>
    </div>
  );
}
